import { defineStore } from 'pinia';

export const usePermissionsStore = defineStore('permissions', {
  state: () => ({
    account: [],
    project: [],
    workspace: []
  }),
  actions: {
    setPermissions(payload) {
      this.account = payload.filter((item) => String(item).startsWith('account.'));
      this.project = payload.filter((item) => String(item).startsWith('project.'));
      this.workspace = payload.filter((item) => String(item).startsWith('workspace.'));
    },

    // ACCOUNT ACL PERMISSIONS

    canUpdateAccount() {
      return this.account.includes('account.update');
    },
    canDeleteAccount() {
      return this.account.includes('account.delete');
    },

    canAddAccountTeamMember() {
      return this.account.includes('account.teammember.add');
    },

    canDeleteAccountTeamMember() {
      return this.account.includes('account.teammember.remove');
    },

    canViewAccountFinancials() {
      return this.account.includes('account.finance.view');
    },

    canAddAccountInfluencer() {
      return this.account.includes('account.influencer.add');
    },

    canDeleteAccountInfluencer() {
      return this.account.includes('account.influencer.remove');
    },

    canUpdateAccountInfluencer() {
      return this.account.includes('account.influencer.update');
    },

    canAddAccountProduct() {
      return this.account.includes('account.product.add');
    },

    canDeleteAccountProduct() {
      return this.account.includes('account.product.remove');
    },

    canUpdateAccountProduct() {
      return this.account.includes('account.product.update');
    },

    canGrantAccountantAccess() {
      return this.account.includes('account.finance.grant');
    },

    // WORKSPACE ACL PERMISSIONS

    canCreateWorkspace() {
      return this.workspace.includes('workspace.add');
    },

    canUpdateWorkspace() {
      return this.workspace.includes('workspace.update');
    },

    canArchiveWorkspace() {
      return this.workspace.includes('workspace.archive');
    },

    canDeleteWorkspace() {
      return this.workspace.includes('workspace.delete');
    },

    canRestoreWorkspace() {
      return this.workspace.includes('workspace.restore');
    },

    canAddWorkspaceTeamMember() {
      return this.workspace.includes('workspace.teammember.add');
    },

    canDeleteWorkspaceTeamMember() {
      return this.workspace.includes('workspace.teammember.remove');
    },

    // PROJECT ACL PERMISSIONS

    canAccessProject() {
      return this.project.includes('project.access');
    },

    canCreateProject() {
      return this.project.includes('project.create');
    },

    canUpdateProject() {
      return this.project.includes('project.update');
    },

    canDeleteProject() {
      return this.project.includes('project.delete');
    },

    canRestoreProject() {
      return this.project.includes('project.restore');
    },

    canAddProjectTeamMember() {
      return this.project.includes('project.teammember.add');
    },

    canDeleteProjectTeamMember() {
      return this.project.includes('project.teammember.remove');
    },

    canAddProjectView() {
      return this.project.includes('project.view.add');
    },

    canUpdateProjectView() {
      return this.project.includes('project.view.update');
    },

    canDeleteProjectView() {
      return this.project.includes('project.view.delete');
    },

    canAddProjectCreator() {
      return this.project.includes('project.creator.add');
    },

    canDeleteProjectCreator() {
      return this.project.includes('project.creator.remove');
    },

    canUpdateProjectCreator() {
      return this.project.includes('project.creator.update');
    },

    canCreatorAccessProjectFinance() {
      return this.project.includes('project.creator.finance');
    },

    canCreateProjectComment() {
      return this.project.includes('project.comment.create');
    },

    canDeleteProjectComment() {
      return this.project.includes('project.comment.delete');
    },

    canModerateProjectComment() {
      return this.project.includes('project.comment.moderate');
    },

    canApproveProjectContent() {
      return this.project.includes('project.content.approve');
    },

    canDeleteProjectContent() {
      return this.project.includes('project.content.delete');
    },

    canLockProjectContent() {
      return this.project.includes('project.content.lock');
    },

    canUploadProjectContent() {
      return this.project.includes('project.content.upload');
    },

    canViewProjectContent() {
      return this.project.includes('project.content.view');
    },

    canVoteProjectContent() {
      return this.project.includes('project.content.vote');
    }
  }
});
